// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require('core-js/stable')
require('regenerator-runtime/runtime')

import Es6Promise from 'es6-promise'
Es6Promise.polyfill()
import Vue from 'vue'
import App from './App'
// import store from './store'
// import router from './router'
import { generateRouter } from './router';
import { generateStore } from './store';
import ElementUI from 'element-ui';
import Vant from 'vant';
import 'vant/lib/index.css';
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import { generateRequestWithHost } from './util/requests';
import { generateAutoLogin } from './util/autoLogin';
import { requests } from 'gweb_tools';
import loadMore from './directives' // 下拉加载更多
Vue.use(loadMore);
Vue.use(Vant);
Vue.prototype.$request = requests.formal;
// import host from './util/baseUrl'
let configPath = ''
if (process.env.NODE_ENV == 'production') {
  configPath = `./config.json?version=${new Date().getTime()}`
} else {
  configPath = `http://localhost:8010/config.json?version=${new Date().getTime()}`
}

async function createVue() {
  axios.get(configPath).then((res) => {
    console.log('get configpath: ', res.data.baseUrl);
    let host = res.data.baseUrl;
    // let host = 'https://guicloudtest.thinkerx.com';
    const request = axios.create({
      baseURL: host
    });
    Vue.prototype.$core=function(){
      let url="",method="get",headers={},data={},success=()=>{},fail=()=>{}
      if(arguments.length==1){
        let obj=arguments[0]
        url=obj.url||url
        method=obj.method||method
        headers=obj.headers||headers
        data=obj.data||data
        success=obj.success||success
        fail=obj.fail||fail
      }else{
        url=arguments[0]||url
        method=arguments[1]||method
        headers=arguments[2]||headers
        data=arguments[3]||data
        success=arguments[4]||success
        fail=arguments[5]||fail
      }
      request({
        // url:host+url,
        url,
        method:method,
        headers:headers,
        data:data,
      }).then(res=>{
        console.log('request: ', url);
        success(res.data)
      },err=>{
        fail(err)
      })
    }
  
    Vue.prototype.$requests = generateRequestWithHost(request);
  
    Vue.prototype.$get=function(url,data,callback){
      Vue.axios.get(host+url,{
        params:data
      }).then(res=>{
        callback(res.data)
      })
    }
    Vue.prototype.$post=function(url,data,callback){
      // Vue.axios.post(host+url,data).then(res=>{
      //   callback(res.data)
      // })
      Vue.axios({
        url:host+url,
        method:"POST",
        data:data
      }).then(res=>{
        callback(res.data)
      })
    }
  
    Vue.use(VueAxios, axios)
    Vue.config.productionTip = false
    Vue.use(ElementUI);
    /* eslint-disable no-new */
    
    const store = generateStore(Vue.prototype.$requests);
    const router = generateRouter(Vue.prototype.$requests, store);
    const app = new Vue({
      store,
      router,
      render: h => h(App)
    }).$mount("#app");
    console.log('create vue complete');
  }, (err) => {
    console.log('err get config: ', err);
  })
}

createVue();


